const link = {};

export default link;
